import React, { useState, useEffect } from "react";
import UserSidebar from "./UserSidebar";
import UserHeader from "./UserHeader";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../api_call";
import "./Dashboard.css";


export default function DataProtection() {

  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const [lockedDates, setLockedDates] = useState({
  regcmp_start_date: false,
  regcmp_end_date: false,
  regcmp_action_date: false,
});


  // ---------------- FORM DATA ----------------
  const [formData, setFormData] = useState({

    regcmp_compliance_id: "",
    regcmp_act: "",
    regcmp_particular: "",
    regcmp_description: "",

    regcmp_start_date: "",
    regcmp_end_date: "",
    regcmp_action_date: "",

    regcmp_reminder_days: 1,

    add_escalation: false,
    regcmp_escalation_email: "",
    regcmp_escalation_reminder_days: "",

    regcmp_status: "Upcoming",
  });


  const FIELD_LABELS = {

    regcmp_compliance_id: "Compliance ID",
    regcmp_act: "Act",
    regcmp_particular: "Compliance Particular",
    regcmp_description: "Description",
    regcmp_start_date: "Start Date",
    regcmp_end_date: "End Date",
    regcmp_action_date: "Action Date",
    regcmp_reminder_days: "Reminder Days",
    regcmp_escalation_email: "Escalation Email",
    regcmp_escalation_reminder_days: "Escalation Reminder Days",
  };


  const [errors, setErrors] = useState({});
  const [successMsg, setSuccessMsg] = useState("");
  const [errorVisible, setErrorVisible] = useState(false);
  const [successVisible, setSuccessVisible] = useState(false);


  // ---------------- DATE NORMALIZER ----------------
  const toInputDate = (value) => {

    if (!value) return "";

    if (/^\d{4}-\d{2}-\d{2}$/.test(value))
      return value;

    const parts = value.split("-");

    if (parts.length === 3) {

      const [dd, mm, yyyy] = parts;

      return `${yyyy}-${mm}-${dd}`;
    }

    const d = new Date(value);

    return isNaN(d)
      ? ""
      : d.toISOString().split("T")[0];
  };


  // ---------------- LOAD SELECTED ROW ----------------
useEffect(() => {

  const savedRow =
    localStorage.getItem("selectedComplianceRow");

  if (!savedRow) return;

  const row = JSON.parse(savedRow);

  // ✅ access nested original object
  const original = row.original || {};

  const startDate =
    toInputDate(original.cmplst_start_date);

  const endDate =
    toInputDate(original.cmplst_end_date);

  const actionDate =
    toInputDate(original.cmplst_action_date);

  setFormData(prev => ({

    ...prev,

    regcmp_compliance_id:
      row.complianceId || original.cmplst_compliance_key || "",

    regcmp_act:
      row.act || original.cmplst_act || "",

    regcmp_particular:
      row.particular || original.cmplst_particular || "",

    regcmp_description:
      row.description || original.cmplst_description || "",

    regcmp_start_date:
      startDate,

    regcmp_end_date:
      endDate,

    regcmp_action_date:
      actionDate,

  }));

   // ✅ lock individually
  setLockedDates({
    regcmp_start_date: !!startDate,
    regcmp_end_date: !!endDate,
    regcmp_action_date: !!actionDate,
  });

}, []);


  // ---------------- INPUT CHANGE ----------------
  const handleInputChange = (e) => {

    const { name, value, type, checked } = e.target;

    setFormData(prev => ({

      ...prev,

      [name]:
        type === "checkbox"
          ? checked
          : value,

    }));

    setErrors({});
    setSuccessMsg("");
  };


  // ---------------- SUBMIT ----------------
  // ---------------- DATE FORMATTER FOR API ----------------
const toDDMMYYYY = (value) => {

  if (!value) return "";

  const [yyyy, mm, dd] = value.split("-");

  return `${dd}-${mm}-${yyyy}`;
};


// ---------------- SUBMIT ----------------
const handleSubmit = async (e) => {

  e.preventDefault();

  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });

  setErrors({});
  setSuccessMsg("");

  const newErrors = {};

  if (!formData.regcmp_start_date)
    newErrors.regcmp_start_date = "Required";

  if (!formData.regcmp_end_date)
    newErrors.regcmp_end_date = "Required";

  if (!formData.regcmp_action_date)
    newErrors.regcmp_action_date = "Required";

  if (
    formData.add_escalation &&
    !formData.regcmp_escalation_email
  ) {
    newErrors.regcmp_escalation_email = "Required";
  }

  if (Object.keys(newErrors).length > 0) {

    setErrors(newErrors);
    return;

  }

  const payload = {

    regcmp_country:
      localStorage.getItem("selectedCountry"),

    regcmp_act:
      formData.regcmp_act,

    regcmp_particular:
      formData.regcmp_particular,

    regcmp_compliance_key:
      formData.regcmp_compliance_id,

    regcmp_description:
      formData.regcmp_description,

    // REQUIRED DATE FIELDS
    regcmp_start_date:
      toDDMMYYYY(formData.regcmp_start_date),

    regcmp_end_date:
      toDDMMYYYY(formData.regcmp_end_date),

    regcmp_action_date:
      toDDMMYYYY(formData.regcmp_action_date),

    regcmp_reminder_days:
      Number(formData.regcmp_reminder_days),

    regcmp_escalation_email:
      formData.add_escalation
        ? formData.regcmp_escalation_email
        : "",

    regcmp_escalation_reminder_days:
      formData.add_escalation
        ? Number(formData.regcmp_escalation_reminder_days || 0)
        : 0,
  };


  try {

    const res = await apiFetch(
      "/data-compliance/add/regulatory",   // ✅ CORRECT ROUTE
      {
        method: "POST",
        body: JSON.stringify(payload),
      }
    );

    if (res?.error)
      throw res;

    setSuccessMsg(
      "✅ Data compliance created successfully"
    );

    setTimeout(() => {

      navigate("/user_dashboard");

    }, 1200);

  }
  catch (err) {

    console.error(err);

    let errorMsg =
      err?.error ||
      "❌ Compliance already exists";

    setErrors({ api: errorMsg });

  }

};

  // ---------------- DATE DISPLAY FORMAT ----------------
  const formatDDMMYYYY = (value) => {

    if (!value) return "";

    const [yyyy, mm, dd] = value.split("-");

    return `${dd}/${mm}/${yyyy}`;
  };


  // ---------------- AUTO-HIDE ERROR ----------------
  useEffect(() => {

    if (errors.api) {

      setErrorVisible(true);

      const timer =
        setTimeout(() => setErrorVisible(false), 4500);

      const removeTimer =
        setTimeout(() => setErrors({}), 5000);

      return () => {

        clearTimeout(timer);
        clearTimeout(removeTimer);
      };
    }

  }, [errors.api]);


  // ---------------- AUTO-HIDE SUCCESS ----------------
  useEffect(() => {

    if (successMsg) {

      setSuccessVisible(true);

      const timer =
        setTimeout(() => setSuccessVisible(false), 4500);

      const removeTimer =
        setTimeout(() => setSuccessMsg(""), 5000);

      return () => {

        clearTimeout(timer);
        clearTimeout(removeTimer);
      };
    }

  }, [successMsg]);


  // ---------------- UI ----------------
  return (

    <div className="add_compliance">

      <UserSidebar
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
      />

      <UserHeader
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
      />

      <div className="form-container">

        <h2>
          Add Compliance
        </h2>


        <div
          className="messages-top"
          style={{
            margin: "0 auto 1rem auto",
            width: "50%"
          }}
        >

          {errors.api &&
            <div className={`login-error ${!errorVisible ? "fade-out" : ""}`}>
              {errors.api}
            </div>
          }


          {successMsg &&
            <div className={`success-msg ${!successVisible ? "fade-out" : ""}`}>
              {successMsg}
            </div>
          }

        </div>


        <form
          onSubmit={handleSubmit}
          className="add-user-form"
        >

          <label>
            Compliance ID
            <input
              value={formData.regcmp_compliance_id}
              disabled
            />
          </label>

          <div></div>


          <label>
            Act
            <input
              value={formData.regcmp_act}
              disabled
            />
          </label>


          <label>
            Compliance Particular
            <input
              value={formData.regcmp_particular}
              disabled
            />
          </label>


          <label>
  Start Date
  <input
  type="date"
  name="regcmp_start_date"
  value={formData.regcmp_start_date}
  onChange={handleInputChange}
  disabled={lockedDates.regcmp_start_date}
  style={{
    backgroundColor:
      lockedDates.regcmp_start_date ? "#f0f0f0" : "white",
    cursor:
      lockedDates.regcmp_start_date ? "not-allowed" : "pointer"
  }}
/>


</label>



         <label>
  End Date
 <input
  type="date"
  name="regcmp_end_date"
  value={formData.regcmp_end_date}
  onChange={handleInputChange}
  disabled={lockedDates.regcmp_end_date}
  style={{
    backgroundColor:
      lockedDates.regcmp_end_date ? "#f0f0f0" : "white",
    cursor:
      lockedDates.regcmp_end_date ? "not-allowed" : "pointer"
  }}
/>


</label>



         <label>
  Action Date
 <input
  type="date"
  name="regcmp_action_date"
  value={formData.regcmp_action_date}
  onChange={handleInputChange}
  disabled={lockedDates.regcmp_action_date}
  style={{
    backgroundColor:
      lockedDates.regcmp_action_date ? "#f0f0f0" : "white",
    cursor:
      lockedDates.regcmp_action_date ? "not-allowed" : "pointer"
  }}
/>


</label>



          <div></div>


          <label>
  Description
  <input
    name="regcmp_description"
    value={formData.regcmp_description}
    onChange={handleInputChange}
  />
</label>




          <div></div>


          <label>
            Reminder Days
            <input
              type="number"
              name="regcmp_reminder_days"
              value={formData.regcmp_reminder_days}
              onChange={handleInputChange}
              style={{ width: "60px" }}
            />
          </label>


          <div></div>


          {/* ESCALATION */}
          <div>

            <input
              type="checkbox"
              name="add_escalation"
              checked={formData.add_escalation}
              onChange={handleInputChange}
            />

            Add Escalation
            <sup><i>Optional</i></sup>

          </div>


          <div></div>


          <label>
            Escalation Email

            <input
              type="email"
              name="regcmp_escalation_email"
              value={formData.regcmp_escalation_email}
              onChange={handleInputChange}
              readOnly={!formData.add_escalation}
              style={{
                backgroundColor:
                  formData.add_escalation
                    ? "white"
                    : "#f0f0f0",

                cursor:
                  formData.add_escalation
                    ? "text"
                    : "not-allowed",
              }}
            />

          </label>


          <label>
            Escalation Reminder Days

            <input
              type="number"
              name="regcmp_escalation_reminder_days"
              value={formData.regcmp_escalation_reminder_days}
              onChange={handleInputChange}
              readOnly={!formData.add_escalation}
              style={{
                width: "60px",
                backgroundColor:
                  formData.add_escalation
                    ? "white"
                    : "#f0f0f0",
              }}
            />

          </label>


          <button
            type="submit"
            className="submit-btn"
          >
            Create Compliance
          </button>


        </form>

      </div>

    </div>
  );
}
